import { Box, Skeleton, SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import React from 'react';
import { useConversationAttachments } from 'services/conversations/hooks';
import { AttachmentItem } from '../AttachmentItem';
import { Accordion } from 'components/Accordion';
import { ConversationItem } from 'modules/conversations/types/ConversationItem';

const buttonContainer: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: 2
};

type Props = {
  conversation: ConversationItem;
};

export const CandidateDocuments: React.FC<Props> = ({ conversation }) => {
  const recipientName = `${conversation.participantFirstName}${
    conversation.participantLastName
      ? `_${conversation.participantLastName}`
      : ''
  }`;

  const {
    attachments,
    downloadAllFiles,
    downloadFile,
    isDownloading,
    isLoading
  } = useConversationAttachments(conversation.id, {
    recipientName
  });

  if (!attachments.length) return null;

  return (
    <Accordion title="Candidate documents">
      <Box>
        {isLoading ? (
          <Skeleton variant="rectangular" width="100%" height={50} />
        ) : (
          <>
            {attachments.map((attachment) => (
              <AttachmentItem
                key={attachment.id}
                attachment={attachment}
                downloadFile={downloadFile}
              />
            ))}
          </>
        )}
        <Box sx={buttonContainer}>
          <Button
            onClick={downloadAllFiles}
            disabled={isDownloading}
            variant="tertiary"
            sx={{
              fontSize: '0.75rem'
            }}
          >
            {isDownloading ? 'Downloading...' : 'Download all'}
          </Button>
        </Box>
      </Box>
    </Accordion>
  );
};
